import React from 'react';
import type {IconProp} from '@fortawesome/fontawesome-svg-core';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faEye} from '@fortawesome/free-solid-svg-icons/faEye';
import type {UserInfoProps} from '../UserInfo';

export const AdfsUserInfo = ({fullName, onToggleDebug}: UserInfoProps): JSX.Element => (
    <>
        {fullName}
        <button
            type="button"
            className="btn btn-link p-0 align-baseline text-white"
            aria-label="Otevřít ladicí přehled"
            onClick={onToggleDebug}
        >
            <FontAwesomeIcon icon={faEye as unknown as IconProp} color="primary" className="text-white mx-2" size="lg"/>
        </button>
    </>
);
